const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgEditArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevos i\u0301conos 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.05,28.06l2.63-2.69a2.83,2.83,0,0,0,0-4.2L92,20.39a2.84,2.84,0,0,0-4.1.2l-2.64,2.63ZM44.68,69.46l7-3.07L87.36,30.74,82.53,26,46.88,61.6l-3.27,6.79A.84.84,0,0,0,44.68,69.46ZM30.23,94.56H75c6.78,0,10.69-3.91,10.69-11.52V42.17l-5.42,5.47v35.1c0,4.2-2.29,6.4-5.37,6.4H30.33c-4,0-6.3-2.2-6.3-6.4V39.29c0-4.2,2.25-6.35,6.3-6.35h35.5l5.47-5.42H30.23c-7.71,0-11.62,3.86-11.62,11.47V83C18.61,90.7,22.52,94.56,30.23,94.56Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditArea);
export default __webpack_public_path__ + "static/media/edit_area.12e8e9255d854afb13852f152b726b23.svg";
export { ForwardRef as ReactComponent };